module.exports = __webpack_public_path__ + "static/img/goodness2.46f5f167.png";